import { assert } from '../../lib/assert-sidecar'
import type { IIJ } from '../../lib/distanceUtil'
import { common } from '../../main/common-sidecar'
import { voyageCamera_shaker } from './voyageCamera_shaker-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageGameStatus_enemyShips } from './voyageGameStatus_enemyShips-sidecar'
import { voyageParticles } from './voyageParticles-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'

export function crewUpdate(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  let useSystemTime = 3
  d.useSystemTimer += ds
  if (d.useSystemTimer > useSystemTime) {
    d.useSystemTimer -= useSystemTime

    // No power needed

    let fp: IIJ = obj
    let tHere = voyageTilemap.getSafeIJ(obj)
    if (tHere) {
      assert.notNil(tHere.system)

      if (tHere.system.ammo > 0) {
        tHere.system.ammo--
        voyageCrew.say(obj, 'Firing!')

        voyageSounds.playFireTorpedo()

        voyageCamera_shaker.shake()

        voyageGameStatus_enemyShips.hurt(25)

        let firePointSys = voyageTilemap.getSystemSafe('fp-' + tHere.text3)
        if (firePointSys) {
          fp = firePointSys
        }

        voyageParticles.createMultiple(
          'torpedo',
          voyageTilemap.convertItoX(fp.i),
          voyageTilemap.convertJtoY(fp.j),
          1,
        )
      } else {
        voyageCrew.say(obj, 'No torpedo loaded!')
      }
    }
  }
}
